import "regenerator-runtime/runtime";
import axios from 'axios';
let React = require('react');

const openPayUrl = process.env.OPENPAY_url;
const merchantId = process.env.OPENPAY_merchant;
const secretKey =  process.env.OPENPAY_secretKey;

class OpenPay {

    async SpeiBankCharge(requestBody, customerId) {
        let APIurl = '';

        if (customerId == null) {
            APIurl = `${openPayUrl}/${merchantId}/charges`;
        }
        else {
            APIurl = `${openPayUrl}/${merchantId}/customers/${customerId}/charges`;
        }

        let config = {
            method: 'post',
            url: APIurl,
            headers: {
                'Content-type': 'application/json', 
                'Authorization': `Basic ${secretKey}`
            },
            data: requestBody
        };

        var OpenPayResponse;

        await axios(config)
            .then(response => {
                console.log(response)
                OpenPayResponse = response.data;


            })
            .catch(error => console.error(error));

        return OpenPayResponse;
    }

    async RedirectPage(requestBody, customerId){
        
        let APIurl = '';
        
        if (customerId == null) {
            APIurl = `${openPayUrl}/${merchantId}/charges`;
        }
        else {
            APIurl = `${openPayUrl}/${merchantId}/customers/${customerId}/charges`;
        }

        let config = {
            method: 'post',
            url: APIurl,
            headers: {
                'Content-type': 'application/json', 
                'Authorization': `Basic ${secretKey}`
            },
            data: requestBody
        };

        var OpenPayResponse;

        await axios(config)
            .then(response => {
                console.log(response)
                OpenPayResponse = response.data;


            })
            .catch(error => console.error(error));

        return OpenPayResponse;

    }

    async CreateClient(requestBody){
        
        let APIurl = `${openPayUrl}/${merchantId}/customers`;

        let config = {
            method: 'post',
            url: APIurl,
            headers: {
                'Content-type': 'application/json', 
                'Authorization': `Basic ${secretKey}`
            },
            data: requestBody
        };

        var OpenPayResponse;

        await axios(config)
            .then(response => {
                console.log(response)
                OpenPayResponse = response.data;


            })
            .catch(error => console.error(error));

        return OpenPayResponse;

    }

    async GetTransaction(transactionId){
        
        let APIurl = `${openPayUrl}/${merchantId}/charges/${transactionId}`;

        let config = {
            method: 'get',
            url: APIurl,
            headers: {
                'Content-type': 'application/json', 
                'Authorization': `Basic ${secretKey}`
            }
        };

        var OpenPayResponse;

        await axios(config)
            .then(response => {
                console.log(response)
                OpenPayResponse = response.data;


            })
            .catch(error => console.error(error));

        return OpenPayResponse;

    }

}

module.exports = OpenPay;